import React from 'react'

const About = () => {
  return (
    <div
      name="about"
      className="w-full pt-16 bg-gradient-to-b from-gray-800 to-black text-white"
    >
      <div className="max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full">
        <div className="pb-8">
          <p className="text-4xl font-bold inline border-b-4 border-gray-500">
            About
          </p>
        </div>

        <div className="space-y-6 text-lg text-gray-300 leading-relaxed">
          <p>
            I got my start in tech over a decade ago focusing on UI and UX
            design. I loved crafting user interfaces and visual layouts, but I
            wanted full control over how those designs actually functioned under
            the hood. That curiosity led me into software engineering.
          </p>

          <p>
            Over the last six plus years, I have built web applications and
            enterprise software using React, Next.js, Node.js, TypeScript,
            Tailwind CSS, PostgreSQL, and Firebase. I handle full system builds,
            custom web integrations, automated workflows, and practical AI
            tools.
          </p>

          <p>
            Having a design background changes how I code. I pay attention to
            spacing, responsive flow, and user feedback just as much as database
            speed and clean code structure.
          </p>
        </div>
      </div>
    </div>
  )
}

export default About
